import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import RestartAltTwoToneIcon from "@mui/icons-material/RestartAltTwoTone";
import useIsMobile from "../hooks/useIsMobile";
import BasicTextFields from "../miui-component/mui-textfield";
import MUIButton from "../miui-component/mui-button";

const TransactionModal = (props) => {
  const { data, holdModalFieldVal } = props;
  const isMobile = useIsMobile();

  return (
    <>
      <Modal {...props} className="stats-modal">
        <Modal.Header>
          <Modal.Title className="w-100">
            <div className="d-flex justify-content-between w-100 align-items-center">
              {" "}
              <div>Transaction Information</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={isMobile ? { height: "50vh", overflow: "auto" } : {}}
        >
          <div className="container-field">
            <div className="row my-4 justify-content-around">
              <div className="col-5">
                <BasicTextFields
                   val={holdModalFieldVal.merchant_code}
                   name="merchant_code"
                   label="Merchant Code"
                  isWidthFull={true}
                  isDisabled={true}
                  //   handleChange={handleChangeField}
                />
              </div>
              <div className="col-5">
                <BasicTextFields
                  val={holdModalFieldVal.order_code}
                  name="order_code"
                  label="Order Code"
                  isWidthFull={true}
                  isDisabled={true}
                  //   handleChange={handleChangeField}
                />
              </div>
                      </div>
                      
            <div className="row my-4 justify-content-around">
              <div className="col-5">
                <BasicTextFields
                  val={holdModalFieldVal.amount}
                  name="amount"
                  label="Amount"
                  isWidthFull={true}
                  isDisabled={true}
                  //   handleChange={handleChangeField}
                />
              </div>
              <div className="col-5">
                <BasicTextFields
                  val={holdModalFieldVal.status}
                  name="status"
                  label="Status"
                  isWidthFull={true}
                  isDisabled={true}
                  //   handleChange={handleChangeField}
                />
              </div>
            </div>

                      
                                    
            <div className="row my-4 justify-content-around">
              <div className="col-5">
                <BasicTextFields
                  val={holdModalFieldVal.startDate}
                  name="Start Date"
                  label="Start Date"
                  isWidthFull={true}
                  isDisabled={true}
                  //   handleChange={handleChangeField}
                />
              </div>
              <div className="col-5">
                <BasicTextFields
                  val={holdModalFieldVal.updatedDate}
                  name="updatedDate"
                  label="Updated Date"
                  isWidthFull={true}
                  isDisabled={true}
                  //   handleChange={handleChangeField}
                />
              </div>
            </div>
            <div className="row my-4 justify-content-around">
              <div className="col-8">
                <div class="mb-3">
                  <label
                    for="exampleFormControlTextarea1"
                    class="form-label h4"
                  >
                    Give your Rate
                  </label>
                  <textarea
                    style={{ borderRadius: "12px" }}
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-5">
              <MUIButton
                //   btnOnClick={() => fetchTransaction(formData)}
                btnLabel="Approve"
                btnStyle={{
                  capitalize: "camelcase",
                  backgroundColor: "#495a69",
                  border: "1px solid #b1adadd9",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "rgb(117 121 124 / 82%)",
                  },
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TransactionModal;
